// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3PojZ","noInteraction":"EventWrapper_noInteraction__1YrKC","pointerPassthrough":"EventWrapper_pointerPassthrough__2NuXO"};